import { EID55_SCARVES } from "./eid55Scarves";

/**
 * Eid Al Etihad 55 gift boxes — edit this file to change what the page shows.
 *
 *  image        file in /public (keep the leading slash)
 *  design       which scarf design this box matches (1–9). The box takes its
 *               title and colors from that scarf (src/data/eid55Scarves.ts),
 *               so scarves and boxes always match.
 *  title / color / accent / description
 *               optional — only set these to override what comes from the scarf.
 *
 * Order in this list = order on the page = box number (01, 02, …).
 */

export interface Localized {
  en: string;
  ar: string;
}

export interface GiftBox {
  id: string;
  image: string;
  design: number;
  title?: Localized;
  color?: string;
  accent?: string;
  description?: Localized;
}

export const EID55_GIFT_BOXES: GiftBox[] = [
  { id: "box-7", image: "/eid55/boxes/box-7.jpg", design: 1 }, // City streets
  { id: "box-9", image: "/eid55/boxes/box-9.jpg", design: 2 }, // The parade
  { id: "box-5", image: "/eid55/boxes/box-5.jpg", design: 3 }, // Ayyala & flags
  { id: "box-8", image: "/eid55/boxes/box-8.jpg", design: 4 }, // Heritage homes
  { id: "box-2", image: "/eid55/boxes/box-2.jpg", design: 5 }, // Coast & dhows
  { id: "box-3", image: "/eid55/boxes/box-3.jpg", design: 6 }, // Those who serve
  { id: "box-6", image: "/eid55/boxes/box-6.jpg", design: 7 }, // Desert camp
  { id: "box-1", image: "/eid55/boxes/box-1.jpg", design: 8 }, // Oasis wildlife
  { id: "box-4", image: "/eid55/boxes/box-4.jpg", design: 9 }, // Dunes & camels
  {
    id: "box-10",
    image: "/eid55/boxes/box-10.jpg",
    design: 10,
    description: {
      en: "A premium tribute to the nation’s pride, crafted with exquisite details celebrating the UAE flag.",
      ar: "تعبير راقٍ يجسد فخر الأمة، صُمم بعناية فائقة لتكريم علم دولة الإمارات العربية المتحدة.",
    },
  },
];

/** Box with everything filled in from its scarf design (overrides win). */
export interface ResolvedGiftBox {
  id: string;
  image: string;
  design: number;
  title: Localized;
  color: string;
  accent: string;
  description?: Localized;
}

export function resolveGiftBox(box: GiftBox): ResolvedGiftBox {
  const scarf = EID55_SCARVES[box.design - 1];
  return {
    id: box.id,
    image: box.image,
    design: box.design,
    title: box.title ?? { en: scarf.en[0], ar: scarf.ar[0] },
    color: box.color ?? scarf.tint,
    accent: box.accent ?? scarf.dot,
    description: box.description,
  };
}

export const EID55_BOXES_RESOLVED: ResolvedGiftBox[] =
  EID55_GIFT_BOXES.map(resolveGiftBox);
